import ApplicationController from "./application_controller.js"

export default class extends ApplicationController {
  static targets = [
    "form",
    "errors",
    "errorList",
    "cardInput",
    "addIndividualBtn",
    "individuals",
    "individualsTotalPrice",
    "addCompanyCheckBtn",
    "companies",
    "companiesTotalPrice",
    "totalPrice1",
    "totalPrice2",
    "tax",
    "taxAmount",
    "stripeTokenHiddenInput",
    "zipHidden",
    "submit"
  ]

  connect() {
    this.stripe = Stripe(this.data.get("stripe-key"))
    this.card = this.stripe.elements().create('card')
    this.card.mount(this.cardInputTarget)

    this.card.addEventListener('change', this.cardInputChanged.bind(this))

    this.connectRemoveEmailAddressButtons()

    $(this.addIndividualBtnTarget).on("click", this.addEmailAddressClicked.bind(this));
    $(this.addCompanyCheckBtnTarget).on("click", this.addCompanyCheckClicked.bind(this));

    this.setPrices(null)
  }

  companyFieldUpdated() {
    this.setPrices()
  }

  removeEmailAddressClicked(event) {
    event.target.closest('.item').remove()
    this.setPrices()
  }

  removeCompanyClicked(event) {
    event.target.closest('.item').remove()
    this.setPrices()
  }

  connectRemoveEmailAddressButtons() {
    $(".remove-individual").on("click", this.removeEmailAddressClicked.bind(this))
  }

  connectRemoveCompanyButtons() {
    $(".remove-company").on("click", this.removeCompanyClicked.bind(this))
  }

  addEmailAddressClicked(event) {
    $(this.individualsTarget).append(this.data.get("individualHtml"))
    this.connectRemoveEmailAddressButtons()
    this.setPrices()
  }

  addCompanyCheckClicked(event) {
    $(this.companiesTarget).append(this.data.get("companyHtml"))
    this.connectRemoveCompanyButtons()
    this.setPrices()
  }

  cardInputChanged(event) {
    let zip = event.value.postalCode
    this.setPrices(zip)
    this.zipHiddenTarget.value = zip
  }

  setPrices(zip) {
    let individualsTotalWithTax = this.withTax(this.individualsTotal(), zip).toFixed(2)
    let companiesTotalWithTax = this.withTax(this.companiesTotal(), zip).toFixed(2)

    $(this.individualsTotalPriceTarget).html("$" + individualsTotalWithTax)
    $(this.companiesTotalPriceTarget).html("$" + companiesTotalWithTax)

    let totalWithTax = Number(individualsTotalWithTax) + Number(companiesTotalWithTax)
    $(this.totalPrice1Target).html('$' + totalWithTax.toFixed(2))
    $(this.totalPrice2Target).html('$' + totalWithTax.toFixed(2))

    let individualsTotal = this.individualsTotal().toFixed(2)
    let companiesTotal = this.companiesTotal().toFixed(2)
    let taxAmount = this.tax(individualsTotal + companiesTotal, zip).toFixed(2)
    $(this.taxAmountTarget).html(taxAmount)
    $(this.taxTarget).toggle(taxAmount > 0)
  }

  isTaxableZip(zip) {
    if(!zip) return false
    let md = zip.match(/^(\d{3})\d{2}$/)
    let prefix = md && md[1]
    return (prefix >= 100 && prefix <= 149) || prefix == "005" || prefix == "063"
  }

  individualsTotalWithTax(zip) {
    let total = this.individualsTotal()
    return total + this.tax(total, zip)
  }

  companiesTotalWithTax(zip) {
    let total = this.companiesTotal()
    return total + this.tax(total, zip)
  }

  individualsTotal() {
    let count = $(this.individualsTarget).children().length + 1
    return count * this.data.get("pricePerActor")
  }

  companiesTotal() {
    let companyCount = $(this.companiesTarget).children().length + 1
    return companyCount * this.data.get("pricePerActor")
  }

  withTax(amount, zip) {
    return amount + this.tax(amount, zip)
  }

  tax(amount, zip) {
    if (!this.isTaxableZip(zip)) return 0

    return amount * this.data.get("taxRate")
  }

  submitForm(event) {
    $.ajax({
      type: "GET",
      url: "/l/bad_actor_check_purchases/validate",
      data: $(this.formTarget).serialize(),
      success: this.formValidated.bind(this)
    });
  }

  async formValidated(data) {
    let errors = data.errorMessages

    this.element.classList.add("loading")
    let result = await this.stripe.createToken(this.card)
    if (result.error) {
      errors.push(result.error.message)
    }

    if (errors.length > 0) {
      this.element.classList.remove("loading")
      $(this.errorListTarget).empty()
      errors.forEach(e => {
        $('<li/>').text(e).appendTo($(this.errorListTarget))
      })
      $(this.errorsTarget).show()
      return
    }

    this.stripeTokenHiddenInputTarget.value = result.token.id
    this.submitTarget.click()
  }
}
